import { Stack, TextField, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import type { IdentifierFormState } from './accountIdentifiers';

interface AccountIdentifierFieldsProps {
  value: IdentifierFormState;
  onChange: (value: IdentifierFormState) => void;
  disabled?: boolean;
}

/**
 * The identifiers a sender may name an account by. Shared by the tenant's account dialog and the
 * accounts page so the two cannot describe the same fields differently.
 */
export function AccountIdentifierFields({ value, onChange, disabled }: AccountIdentifierFieldsProps) {
  const { t } = useTranslation();

  const field = (key: keyof IdentifierFormState) => ({
    value: value[key],
    disabled,
    onChange: (event: React.ChangeEvent<HTMLInputElement>) =>
      onChange({ ...value, [key]: event.target.value }),
  });

  return (
    <Stack spacing={2.5}>
      <Typography variant="body2" color="text.secondary">
        {t('admin.identifiers.intro')}
      </Typography>
      <TextField
        label={t('admin.identifiers.ico')}
        {...field('registrationNumber')}
        helperText={t('admin.identifiers.icoHelp')}
      />
      <TextField
        label={t('admin.identifiers.dic')}
        {...field('taxId')}
        helperText={t('admin.identifiers.dicHelp')}
      />
      <TextField
        label={t('admin.identifiers.icdph')}
        {...field('vatId')}
        helperText={t('admin.identifiers.icdphHelp')}
      />
      <TextField
        label={t('admin.identifiers.participant')}
        {...field('participantId')}
        helperText={t('admin.identifiers.participantHelp')}
      />
      <TextField
        label={t('columns.country')}
        {...field('countryCode')}
        helperText={t('admin.identifiers.countryHelp')}
      />
    </Stack>
  );
}
